import { render } from "./ChosenInitiativesBoards.vue?vue&type=template&id=69d4add7&scoped=true"
import script from "./ChosenInitiativesBoards.vue?vue&type=script&lang=js"
export * from "./ChosenInitiativesBoards.vue?vue&type=script&lang=js"

import "./ChosenInitiativesBoards.vue?vue&type=style&index=0&id=69d4add7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d4add7"]])

export default __exports__